import { ContainerModule } from 'inversify';
import questionAttemptsStoreModule, { QuestionAttemptStoreModuleSymbol } from './question-attempt-store-module';
import { QuestionAttemptQuerySymbol } from './question-attempt-query';

export const questionAttemptStateModule = new ContainerModule((bind) => {
  bind(QuestionAttemptStoreModuleSymbol).toConstantValue(questionAttemptsStoreModule);
  bind(QuestionAttemptQuerySymbol).toDynamicValue((c) => c.container.get(QuestionAttemptStoreModuleSymbol))
});
